import React from "react";

import { useTranslate } from "localization";
import styled from "styled-components";
import { Alert, Table } from "ui/core";

export interface EmptyProps {
  size: number;
  message?: string;
}

const Empty: React.FC<EmptyProps> = ({ size, message }) => {
  const { translate } = useTranslate();

  return (
    <WideCell colSpan={size}>
      <Alert variant="empty">{message || translate("emptyAlert")}</Alert>
    </WideCell>
  );
};

export const WideCell = styled(Table.Cell)`
  grid-column: 1 / -1 !important;
  display: block;
`;
export default Empty;
